export const initSubmitCallButton = () => {
  const callBtn = document.querySelector("#ins-call-btn");
  const submitBtn = document.querySelector("#ins-submit-btn");
  if (callBtn) {
    callBtn.addEventListener("click", () => {
      submitBtn.classList.remove('d-none');
      callBtn.classList.add('d-none');
    });
  }
};
